import type { BookingSearch } from "@/lib/bookingSearch"
import { emptyBookingSearchBusinessesPayload } from "@/lib/bookingSearch/emptyBusinessesPayload"
import type { Caching } from "@/lib/caching"

export const buildBookingSearchResults = ({
  businesses = emptyBookingSearchBusinessesPayload,
}: {
  businesses?: Caching.Payload<BookingSearch.BusinessMirror>
} = {}): BookingSearch.Results => {
  return {
    businesses,
  }
}
